import { useRefCallback, useSingleton } from '@bydesign-ui/hooks';
import { useCallback, useEffect } from 'react';
import { Container } from '../../../models/sorter';
import { useSorter } from './useSorter';
export function useSorterContainer(options) {
  var name = options.name,
      data = options.data,
      mode = options.mode,
      convertData = options.convertData,
      isValidContainer = options.isValidContainer,
      onValueChange = options.onValueChange,
      onDraggingChange = options.onDraggingChange;
  var sorter = useSorter();
  var container = useSingleton(function () {
    return new Container(name, sorter);
  });
  var onValueChangeCallback = useRefCallback(onValueChange);
  var onDraggingChangeCallback = useRefCallback(onDraggingChange);
  container.updateOptions({
    data: data,
    mode: mode,
    convertData: convertData,
    isValidContainer: isValidContainer
  });
  var onRemove = useCallback(function (index) {
    container.removeElement(index);
  }, []);
  useEffect(function () {
    container.addListener('change', onValueChangeCallback);
    container.addListener('dragging-change', onDraggingChangeCallback);
    return function () {
      container.removeListener('change', onValueChangeCallback);
      container.removeListener('dragging-change', onDraggingChangeCallback);
      container.dispose();
    };
  }, []);
  return {
    onRemove: onRemove
  };
}